import React, { useEffect, useState } from "react";
import s from "./RaffleModal.module.css";

//assets
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

//materialUi
import {
  CircularProgress,
  Grid,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import gamesService from "../../../../../../api/games/GamesService";
import useTranslationException from "../../../../../../helpers/exceptions";
import Swal from "sweetalert2";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const RaffleModal = ({ open, setOpen, selectRaffle }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);

  const [items, setItems] = useState([]);

  //paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [telekino, setTelekino] = useState({});
  const handlePaginate = (e, v) => {
    setPage(v);
  };
  const [sort, setSort] = useState({
    criteria: "ASC",
    field: "name",
  });

  const dateNow = new Date();
  const currentDate = dateNow.toISOString();
  const dispatch = useDispatch();

  const getData = () => {
    setLoading(true);
    if (telekino?.id) {
      gamesService
        .getRaffle(telekino?.id, 1, page, 10, currentDate)
        .then((res) => {
          setItems(res.content);
          setTotalPages(res.totalPages);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    } else {
      gamesService
        .searchGame("Telekino", dispatch)
        .then((res) => {
          let gameResponse = res.content[0];
          if (gameResponse?.id) {
            setTelekino(gameResponse);
            gamesService
              .getRaffle(gameResponse?.id, 1, page, 10, currentDate)
              .then((res) => {
                setItems(res.content);
                setTotalPages(res.totalPages);
              })
              .then(() => setLoading(false))
              .catch((e) => {
                showExpetion.showErrorModalForServiceException(
                  e,
                  { icon: "warning" },
                  t("anErrorOccurred,TryAgain"),
                  t("sorryErrorOcurred"),
                );
                setLoading(false);
              });
          } else {
            Swal.fire("", t("noRaffleForTelekino"), "warning");
            setLoading(false);
            setOpen(false);
          }
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("raffles")} Telekino</p>
                <span>{t("select")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            {loading ? (
              <Grid item xs={12} className={s.loader}>
                <CircularProgress />
              </Grid>
            ) : items?.length ? (
              <Grid item container xs={11} className={s.data}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("drawNumber")}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("lottery")}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("drawDate")}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item, i) => {
                        let date = item.raffleDate
                          ?.split("T")[0]
                          .split("-")
                          .reverse()
                          .join("-");
                        return (
                          <React.Fragment key={item.id}>
                            <TableRow
                              sx={{
                                "&:hover": {
                                  backgroundColor: "secondary.light",
                                },
                              }}
                              onClick={() => {
                                selectRaffle(item);
                                setOpen(false);
                              }}
                            >
                              <TableCell
                                sx={{
                                  ...cellStyles,
                                  backgroundColor:
                                    i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                }}
                              >
                                {item.number}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  ...cellStyles,
                                  backgroundColor:
                                    i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                }}
                              >
                                {item.lottery.name}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  ...cellStyles,
                                  backgroundColor:
                                    i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                }}
                              >
                                {date}
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    height: "10%",
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePaginate}
                    color="primary"
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40vh",
                  fontSize: "1.5rem",
                  fontWeight: "300",
                }}
              >
                {t("noResults")}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RaffleModal;
